import { IContentUpdateClientFormType, Contrato } from "@/shared/interfaces"
import { CustomTextField, CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui";
import { UseFormReturn } from "react-hook-form";
import { gridSizeMdLg3, gridSizeMdLg6 } from "@/shared";

interface DatosContratoClienteProps {
  contract?: Contrato;
  form: UseFormReturn<IContentUpdateClientFormType>;
}

const DatosContratoCliente: React.FC<DatosContratoClienteProps> = ({
  // contract,
  form
}) => {
  const { errors } = form.formState;


  return (
    <>
      {/* ===================== Contract Info ===================== */}
      <TabTextLabel text="Datos del Contrato" />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Tipo de contrato`}
        defaultValue={form.getValues().requiere_contrato_fisico ? 'FISICO' : 'DIGITAL'}
        size={gridSizeMdLg6}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Tercera edad`}
        defaultValue={form.getValues().es_tercera_edad ? 'SI' : 'NO'}
        size={gridSizeMdLg3}
      />

      <CustomTextFieldNoForm
        disabled={true}
        label={`Discapacitado`}
        defaultValue={form.getValues().es_discapacidad ? 'SI' : 'NO'}
        size={gridSizeMdLg3}
      />


      <CustomTextField
        name="planLabel"
        label="Plan"
        control={form.control}
        defaultValue={form.getValues().planLabel || ''}
        error={errors.planLabel}
        helperText={errors.planLabel?.message?.toString() ?? ''}
        shrink
        disabled
      />

      <CustomTextField
        label="Tipo de Contrato"
        name="tipo_servicio"
        control={form.control}
        defaultValue={form.getValues().tipo_servicio || ''}
        error={errors.tipo_servicio}
        helperText={errors.tipo_servicio?.message}
        shrink
        type="tipo_servicio"
        disabled
        size={gridSizeMdLg6}
      />
      <CustomTextField
        label="Permanencia"
        name="permanencia"
        control={form.control}
        defaultValue={form.getValues().permanencia || ''}
        error={errors.permanencia}
        helperText={errors.permanencia?.message}
        shrink
        type="permanencia"
        disabled
        size={gridSizeMdLg6}
      />

      <CustomTextField
        name="numero_contrato"
        label="No. Contrato"
        control={form.control}
        defaultValue={form.getValues().numero_contrato || ''}
        error={errors.numero_contrato}
        helperText={errors.numero_contrato?.message?.toString() ?? ''}
        shrink
        disabled
      />
    </>
  )
}

export default DatosContratoCliente;